import _JSXStyle from "styled-jsx/style";
import { spacers, theme, colors, sharedPropTypes } from '@dhis2/ui-constants';
import cx from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
const Help = _ref => {
  let {
    children,
    valid,
    error,
    warning,
    className,
    dataTest = 'dhis2-uicore-help'
  } = _ref;
  return /*#__PURE__*/React.createElement("p", {
    "data-test": dataTest,
    className: _JSXStyle.dynamic([["1832050605", [spacers.dp4, theme.default, colors.blue700, theme.error, colors.yellow800]]]) + " " + (cx(className, {
      valid,
      error,
      warning
    }) || "")
  }, children, /*#__PURE__*/React.createElement(_JSXStyle, {
    id: "1832050605",
    dynamic: [spacers.dp4, theme.default, colors.blue700, theme.error, colors.yellow800]
  }, [`p.__jsx-style-dynamic-selector{margin-top:${spacers.dp4};margin-right:0;margin-bottom:0;margin-left:0;font-size:12px;line-height:14px;color:${theme.default};}`, `.valid.__jsx-style-dynamic-selector{color:${colors.blue700};}`, `.error.__jsx-style-dynamic-selector{color:${theme.error};}`, `.warning.__jsx-style-dynamic-selector{color:${colors.yellow800};}`]));
};
Help.propTypes = {
  children: PropTypes.string,
  className: PropTypes.string,
  dataTest: PropTypes.string,
  error: sharedPropTypes.statusPropType,
  valid: sharedPropTypes.statusPropType,
  warning: sharedPropTypes.statusPropType
};
export { Help };